interface OptionRowLabelProps {
  option: string;
  description?: string;
}

export const OptionRowLabel = ({ option, description }: OptionRowLabelProps) => (
  <span className="flex flex-col">
    <span>{option}</span>
    {!!description && <span className="text-sm text-muted-foreground">{description}</span>}
  </span>
);
